export enum UploadFileEnum {
  IMAGE_MOBILE='image_mobile',
	IMAGE_DESKTOP='image_desktop'
}